import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// We don't display blur effects if the network as a gradient background as the render will be ugly
const useDisplayBlurEffects = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  return networkData?.theming?.fo?.fo_background_type === 'SOLID';
};

export default useDisplayBlurEffects;
